<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
            color="secondary"
            outlined
            class="mr-1 reportBackBtn"
            to="/admin/reports/user"
          >
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to User
            Reports
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="user-report-button-wrapper" v-if="serverItemsLength > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" class="add-course-button" dark outlined v-bind="attrs" v-on="on">
                More
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item key="archiveData" @click.prevent="showCompletedCoursePanel()">
                <v-list-item-title>Archive Course(s) Data</v-list-item-title>
              </v-list-item>
              <v-list-item key="email" @click.prevent="exportCsv('excel')">
                <v-list-item-title>Email Excel Report</v-list-item-title>
              </v-list-item>
              <v-list-item key="notcompleted" @click.prevent="showNotCompletedCoursePanel()">
                <v-list-item-title>Mark Course(s) Completed</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Courses"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applyCourseSearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col md="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
<v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories search-box" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
          </v-select> 
          </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="courses"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
              }"
            >
              <template v-slot:item.test_score="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    {{ item.test_score }}%
                  </span>
                  <span v-else>T.B.C</span>
                </span>
              </template>
              <template v-slot:item.progress="{ item }">
                {{ item.progress }}%
              </template>
              <template v-slot:item.has_test="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    <span v-if="item.test_passed">
                      <v-icon color="green">fa-check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon color="red">fa-times</v-icon>
                    </span>
                  </span>
                  <span v-else> T.B.C </span>
                </span>
              </template>

              <!-- 5: Take Test / View Course -->
              <template v-slot:item.id="{ item }">
                <!-- 1: Archive Course -->
                 
                 
                  <v-tooltip bottom v-if="item.state == 3">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click.prevent="archiveUserCourse(item.id)"
                    >
                      <v-icon small>fas fa-archive</v-icon>
                    </v-btn>
                  </template>
                  <span>Archive</span>
                </v-tooltip>

                 <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click.prevent="
                        showUserCourseHistoryPanel(item.id)
                      "
                      v-if=" item.history_exists"
                    >
                      <v-icon small>fas fa-history</v-icon>
                    </v-btn>
                  </template>
                  <span>View Completed Course History</span>
                </v-tooltip>
                  <!-- 3: Download Cert / View Course -->
                  <v-tooltip bottom  v-if="item.certificate_url != null">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        if="item.state == 2"
                        v-on="on"
                        color="secondary"
                        class=""
                        text
                        small
                        @click="generatePDF(item.certificate_url)"
                      >
                        <v-icon small>fa-certificate</v-icon>
                      </v-btn>
                    </template>
                    <span>Download Certificate</span>
                  </v-tooltip>
                 <!-- <v-tooltip v-if="!item.has_test" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        if="item.state == 2"
                        v-on="on"
                        color="secondary"
                        class="ml-1"
                        outlined
                        small
                        @click="generatePDF(item.certificate_url)"
                      >
                        <v-icon small>fa-certificate</v-icon>
                      </v-btn>
                    </template>
                    <span>Download Certificate</span>
                  </v-tooltip> -->
                <!--<v-btn color="secondary">View Course</v-btn>
          <v-btn color="secondary">Contine</v-btn>-->
                <!--<v-btn v-else :to="'/courses/player/' + item.course_id" color="secondary">View</v-btn>-->
                <!--<v-btn :ref="'cert-loading-'+item.id" class="ml-1" @click.prevent="generatePDF(item.id)" color="secondary">Certificate</v-btn>-->
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import userAPI from '@/api/user.js';
import courseAPI from '@/api/course.js';
import { EventBus } from '@/event-bus.js';
import ShowUserCourseHistory from '@/components/admin/course/ShowUserCourseHistory';
import CompletedCourses from '@/components/admin/course/CompletedCourse';
import NotCompletedCourse from '@/components/admin/course/NotCompletedCourses';
export default {
  name: 'ActivityWidget',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'title', sortable: false },
        { text: 'Status', value: 'state_text', sortable: false },
        {
          text: 'Date Enrolled',
          value: 'enrolled_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Started',
          value: 'start_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Completed',
          value: 'complete_date_formatted',
        },
        { text: 'Progress %', value: 'progress',},
        { text: 'Deadline', value: 'deadline_formatted', sortable: false },
        { text: 'Test Score', value: 'test_score', sortable: false },
        { text: 'Passed Test', value: 'has_test', sortable: false },

        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      id: this.$route.params.id,
      courses: [],
      loading: false,
      pagination: {},
      options: {},      
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
      confirmArchive: 'Are you sure you wish to archive course for this user?',  
      successArchiveMessage: 'Course Archived Successfully.',
      categories: [],
      selectedCategory: [],
      search: '',
      searchParams: '',
    };
  },
  props: {
    
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      const options = { ...this.options }

      const sortFieldMap = {
        complete_date_formatted: 'complete_date'
      }

      if (Array.isArray(options.sortBy) && options.sortBy.length > 0) {
        const field = options.sortBy[0]

        if (sortFieldMap[field]) {
          options.sortBy = [sortFieldMap[field]]
        }
      }
      return this.$gf.getQueryString(options, this.serverItemsLength)
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
    this.getAllCourseCategories();
    this.loadSearch();
  },
  methods: {
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.getCourses();
      });
    },
    generatePDF(url) {
      if (url != null) {
        window.open(url, '_blank');
      }
    },
    getCourses() {
      this.loading = true;
      userAPI.getArchivedUserCourses(this.id, this.params,this.searchParams).then((resp) => {
        this.courses = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    exportCsv(type) {
      this.loading = true;
      courseAPI
        .exportUserCourseReportCSV(
          this.id,
          '?page=1&orderBy=&sortedBy=asc&limit=' + this.pagination.total,
          '&type=' + type
        )
        .then((resp) => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    archiveUserCourse(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processArchiveUserCourse(toast, id),
          },
        ],
      });
    },
    processArchiveUserCourse(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.archiveUserCourse(id).then(() => {
        this.getCourses();
        this.$snotify.success(this.successArchiveMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    showUserCourseHistoryPanel(id) {
      this.$showPanel({
        component: ShowUserCourseHistory,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCompletedCoursePanel() {
      this.$showPanel({
        component: CompletedCourses,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
    applySearch() {
      this.options.page = 1;
      this.getCourses();
      this.saveSearch();
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      localStorage.removeItem('course-report-search');
      this.applyCourseSearch();
    },
    applyCourseSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.searchParams = this.search && this.search.length > 0
      ? '&course_name=' + this.search : '';
      
      if (this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
      }

      this.getCourses();
      
      if(this.search && this.search.length > 0){
        this.saveSearch();
      }
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
    },
    filterCoursesByCategories(){
      this.applyCourseSearch();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearch()
    },
    saveSearch() {
      // Save search value to localStorage
      localStorage.setItem('user-course-report-search', this.search);
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('user-course-report-search');
      
      if (savedSearch && savedSearch !== 'null') {
        this.search = savedSearch;
      }
    },
     showNotCompletedCoursePanel() {
      this.$showPanel({
        component: NotCompletedCourse,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
  },
};
</script>

<style scoped>
.completed {
  color: #ffaf19;
}
.inprogress {
  color: #00e396;
}
.notstarted {
  color: #008efb;
}

.user-report-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}
.reportBackBtn::before{
  opacity: 0.18;
}
.v-btn:not(.v-btn--round).v-size--small{
  min-width: 25px !important;
  padding: 0 4.5px !important;
}
@media (max-width: 960px) {
  .user-report-button-wrapper {
    justify-content: start;
  }
}
</style>
